module.exports = __webpack_public_path__ + "img/KEMER.afbb9379.png";